/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const { detect } = require('detect-browser');
const browser = detect();

if (environment.production) {
  enableProdMode();
}

if(environment.env != 'production') {
  console.log('Loaded environment ', environment.env)
  document.querySelector('link[rel="icon"]').setAttribute('href', '/assets/favicon-staging.png');
}

declare const firebase;
declare const window;

firebase.initializeApp(environment.firebaseConfig);
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
let firebaseInitiated = false;
firebase.auth().onAuthStateChanged((user) => {
  if(!user) return initialize();
  user.getIdTokenResult(true).then((result) => {
    window.currentUser = result.claims;
    initialize();
  });
});


function initialize() {
  if (firebaseInitiated) return;
  firebaseInitiated = true;
  platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
}
// Blocking browsers disabled :)
// if(browser.name === 'chrome' || environment.env == 'staging' || environment.env == 'dev') {
//   platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
// } else {
//   window.location.href="/assets/browser.html";
// }


